import { createContext, useContext, useEffect, useState } from "react";
import axios from "../axios";
import { Sentry } from "../sentry";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem("user");
      return stored ? JSON.parse(stored) : null;
    } catch { return null; }
  });

  useEffect(() => {
    if (user) {
      Sentry.setUser({ id: user.id, email: user.email, role: user.role });
    } else {
      Sentry.setUser(null);
    }
  }, [user]);

  const login = (userData, token) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  // POST /logout works for all roles (admin, provider, customer)
  const logout = async () => {
    try { await axios.post("/logout"); } catch { /* token may already be invalid */ }
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
